// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { IfFeature } from '@tectonics/prs/feature';
import { useAllFeatures } from '@tectonics/prs/payment-spec';

import { BankList } from './bank-list';
import { ExternalPayProviderList } from './externalpayprovider-list';
import { Empty } from '../../../../atoms';
import { useUserInputValue } from '@tectonics/prs/user-input-values';
import { FieldColombianAddress } from '../../customer-form/colombian';

export function ExternalPayProviderForm(): Node {
  const allFeatures = useAllFeatures();
  const [selectedPaymentMethodCode] = useUserInputValue('selectedExternalPayProvider');

  return(
    <Root>
      <IfFeature allFeatures={allFeatures} wanted="field_colombian_externalpayprovider_code">
        <ExternalPayProviderList />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_colombian_address">
        <FieldColombianAddress />
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="field_colombian_externalpayprovider_bank_list">
        {renderExternalPayProviderBankListByPaymentCode(selectedPaymentMethodCode)}
      </IfFeature>
    </Root>
  );
}

function renderExternalPayProviderBankListByPaymentCode(paymentMethodCode: string): Node {
  switch (paymentMethodCode) {
    case 'achpse':
      return <BankList />;
    default:
      return <Empty />;
  }
}

const Root = styled.div``;
